import clsx from "clsx";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();

  return (
    <p
      className={clsx(
        "uppercase px-5 pb-10 pt-5 w-full romanBold bg-grey-600 text-center tracking-[0.1em]",
        pathname === "/" ? "text-white" : "text-riskcomfort-500"
      )}
    >
      the home of motocross decals, motocross numbers, motocross graphics &
      motocross bike graphic kits
    </p>
  );
};

export default Footer;
